import {
  MapPin,
  ShieldCheck,
  Zap,
  Route,
  Trees,
  TrendingUp,
} from "lucide-react";
import { Reveal } from "./Reveal";
import { AMENITIES } from "../data/content";

const ICONS = { MapPin, ShieldCheck, Zap, Route, Trees, TrendingUp };

export const Amenities = () => {
  return (
    <section
      id="amenities"
      data-testid="amenities-section-container"
      className="py-20 md:py-28 px-4 sm:px-8 lg:px-16 bg-[#2C5F2D] relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.04] bg-[radial-gradient(circle_at_1px_1px,#fff_1px,transparent_0)] [background-size:28px_28px]" />
      <div className="max-w-7xl mx-auto relative">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-16">
            <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-[#EAC9B8] mb-4">
              Built for Comfort & Security
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
              {AMENITIES.title}
            </h2>
            <p className="mt-5 text-lg text-white/70 leading-relaxed">
              {AMENITIES.subtitle}
            </p>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {AMENITIES.items.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <Reveal key={item.name} delay={i * 0.07}>
                <div
                  data-testid={`amenity-card-${i}`}
                  className="group h-full rounded-2xl bg-[#1E4320]/60 border border-white/10 backdrop-blur-sm p-8 transition-all duration-300 hover:bg-[#F7F3EE] hover:-translate-y-1.5 hover:shadow-2xl"
                >
                  <div className="h-14 w-14 rounded-xl bg-[#C15B3D] grid place-items-center mb-6 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3">
                    <Icon className="h-7 w-7 text-white" strokeWidth={1.8} />
                  </div>
                  <h3 className="font-serif text-xl text-white mb-2 transition-colors group-hover:text-[#1F291E]">
                    {item.name}
                  </h3>
                  <p className="text-white/65 leading-relaxed text-[15px] transition-colors group-hover:text-[#5C6B5A]">
                    {item.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
